/* eslint-disable */
import { fetch } from '@/libs/http/baseService';

// 公共api
export const getList = (params) => fetch.get(`/api/user/page`, {params: params});

// 根据模块查询产品类别 	应用专区：1:产品 2:新闻
export const getApplyZoneMenu = (params) => fetch.get(`/api/webMenu/getApplyZoneMenu`, {params: params});

// 获取当前登录人拥有菜单
export const getCurrentMenu = (params) => fetch.get(`/api/menu/findByMe`, {params: params});

// 设置用户皮肤
export const setSkin = (skin) => fetch.post(`/api/user/setSkin/${skin}`);

export const getNameLike = (params) => fetch.get(`/api/user/getNameLike`, {params: params});
